import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var ShareLink = styled.div.withConfig({
  displayName: "ShareLink",
  componentId: "sc-d5qbvk-0"
})(["display:block;width:50%;padding:7px 9px;", ";color:", ";a{position:relative;padding-left:24px;color:currentColor;color:", ";transition:color 0.15s ease;&:hover{opacity:0.75;}}svg{position:absolute;top:50%;left:0;margin-top:-8px;}"], getFont(0), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.fontL;
}, function (_ref2) {
  var theme = _ref2.theme,
    color = _ref2.color;
  return color ? color : theme.colors.font;
});